<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees class="row my-5"></app-nav-gestion-donnees>

	<div *ngIf="missionRequest" class="my-3 theme-main-color">
		<div class="row">
			<div class="d-flex justify-content-between">
				<div class="">
					<span
						(click)="goBack()"
						class="fs-4 hand-cursor"
						[ngClass]="{
							'theme-red-color':
								missionRequest?.state &&
								etat[missionRequest?.state] !== etat.UNDER_REVIEW
						}"
						><i class="bi bi-arrow-left me-3" aria-hidden="true"></i
						>{{
							missionRequest.missionType
								? missionRequest.missionType.type
								: LABEL_INTERVENTION_CAPITALIZED
						}}
						<span *ngIf="!isReunion"
							>-
							{{
								isSESSAD
									? !missionRequest.careSpecialty ||
									  missionRequest.careSpecialty?.name === 'Sans'
										? 'Sans spécialité'
										: missionRequest.careSpecialty?.name
									: getCareSkillsAsString()
							}}
							{{ ' - ' + etat[missionRequest?.state] }}</span
						>
					</span>
				</div>

				<div>
					<a
						(click)="validateCancelMission()"
						class="btn theme-red-button px-4 mr-2"
					>
						Annuler {{ LABEL_INTERVENTION }}
					</a>
					<a
						*ngIf="
							missionRequest.assignedToPlanning &&
							State[this.missionRequest.state].includes(State.CANCELED)
						"
						(click)="undoCancelMission()"
						class="btn theme-red-button px-4 mr-2"
					>
						Réactiver {{ LABEL_INTERVENTION }}
					</a>
					<a
						*ngIf="isDeletable"
						(click)="openModalConfirmDelete(deleteFormation)"
						class="btn theme-red-button px-4 ms-3"
					>
						Supprimer {{ LABEL_INTERVENTION }}
					</a>
				</div>
			</div>
			<div class="row" [ngClass]="isFormReadOnly ? 'my-5' : 'mt-5 mb-1'">
				<span class="fw-bold fs-5">Informations</span>
			</div>
			<div
				class="row"
				*ngIf="
					missionRequest.assignedToPlanning &&
					missionRequest.nombreIntervenant === 1 &&
					!isFormReadOnly &&
					!this.missionHasToBeUnassigned &&
					!this.isProfessionnelSAE
				"
			>
				<div class="alert alert-warning text-center" role="alert">
					Cette {{ LABEL_INTERVENTION }} est affectée à quelqu'un. Pour la
					modifier davantage, vous devez la désaffecter.
				</div>
			</div>
			<div
				class="row"
				*ngIf="
					missionRequest.assignedToPlanning &&
					missionRequest.nombreIntervenant === 1 &&
					this.missionHasToBeUnassigned &&
					!isFormReadOnly
				"
			>
				<div class="alert alert-warning text-center" role="alert">
					Cette mission sera désaffectée si vous validez vos modifications.
				</div>
			</div>
		</div>
		<div class="row rounded bg-light">
			<form
				id="formationDetailForm"
				[formGroup]="formationDetailForm"
				(ngSubmit)="onSubmit()"
			>
				<div class="row my-4">
					<div class="col-4">
						<label for="model" class="form-label fw-bold">Dossier DH</label>
						<div class="col-4" *ngIf="isFormReadOnly">
							<span class="form-control-plaintext">{{
								missionRequest.parcoursId ? missionRequest.parcoursId : ''
							}}</span>
						</div>
					</div>
					<div class="col-lg-4 col-12" *ngIf="!isReunion">
						<label
							for="beneficiaire"
							class="form-label fw-bold theme-main-color"
						>
							{{ LABEL_BENEFICIAIRE }}</label
						>
						<span
							*ngIf="isFormReadOnly || !canBeFullyModified"
							class="form-control-plaintext"
							>{{ missionRequest.beneficiaire?.firstName }}
							{{ missionRequest.beneficiaire?.lastName }}</span
						>
						<input
							*ngIf="!isFormReadOnly && canBeFullyModified"
							autocomplete="off"
							(keyup)="beneficiaireKeyUp($event.target)"
							formControlName="beneficiaire"
							[typeahead]="listBeneficiaireMapped"
							typeaheadOptionField="name"
							[typeaheadItemTemplate]="itemTemplateTypeaheadBeneficiaire"
							[typeaheadMinLength]="0"
							placeholder="{{ LABEL_BENEFICIAIRE | titlecase }}"
							class="form-control"
							[typeaheadScrollable]="true"
							(typeaheadOnSelect)="typeaheadBeneficiaireOnSelect($event)"
							[ngClass]="{
								'is-invalid':
									!selectedBeneficiaire &&
									formationDetailForm?.errors?.beneficiaireRequired,
								'is-valid':
									(beneficiaire.dirty || beneficiaire.touched) &&
									beneficiaire.valid &&
									selectedBeneficiaire
							}"
						/>
						<ng-template
							#itemTemplateTypeaheadBeneficiaire
							let-model="item"
							let-index="index"
						>
							<span>{{ model.name }}</span>
						</ng-template>
						<div
							*ngIf="formationDetailForm.errors?.beneficiaireRequired"
							class="text-danger"
						>
							<span *ngIf="!selectedBeneficiaire"
								>Le choix d'un {{ LABEL_BENEFICIAIRE }} est requis</span
							>
						</div>
					</div>
				</div>
				<div class="row my-4">
					<div *ngIf="!isReunion && !isSAAD" class="col-12 col-lg">
						<label for="competences" class="form-label fw-bold"
							>Compétence(s)</label
						>
						<div class="row">
							<div
								class="col check"
								*ngFor="
									let competence of listCompetences | orderBy : 'name' : 'asc'
								"
							>
								<input
									[type]="'checkbox'"
									name="{{ competence }}"
									class="form-check-input"
									[value]="competence"
									[checked]="isCompetenceCheck(competence)"
									[disabled]="
										isFormReadOnly ||
										isProfessionnelSAE ||
										(isSAE && isCompetencesElementaires(competence))
									"
									[ngClass]="{
										'theme-main-color-check': isCompetenceCheck(competence)
									}"
									(change)="updateSelectedCompetence($event, competence)"
								/>
								<label class="ms-2 form-check-label text-dark">
									{{ competence.name.replaceAll('_', ' ') }}
								</label>
							</div>
						</div>
					</div>
				</div>
				<div class="row my-4">
					<!-- DATE -->
					<div class="col-lg-4 col-12">
						<label
							for="inputDateFormation"
							class="form-label theme-main-color fw-bold"
							>Date de {{ LABEL_INTERVENTION }}</label
						>
						<span
							*ngIf="isFormReadOnly || !canBeFullyModified"
							class="form-control-plaintext"
							>{{ missionRequest.date | date : 'dd/MM/yy' }}</span
						>

						<input
							*ngIf="!isFormReadOnly && canBeFullyModified"
							[isDisabled]="isFormReadOnly || !canBeFullyModified"
							[disabled]="isFormReadOnly || !canBeFullyModified"
							autocomplete="off"
							type="text"
							bsDatepicker
							class="form-control"
							id="inputDateFormation"
							formControlName="date"
							name="date"
							[ngClass]="{
								'bg-transparent border-light ps-0':
									isFormReadOnly || !canBeFullyModified,
								'is-invalid': date.invalid,
								'is-valid': date.dirty && date.valid
							}"
						/>
						<div
							*ngIf="
								date.invalid &&
								(date.dirty || date.touched || date.errors?.required)
							"
							class="invalid-feedback"
						>
							<span *ngIf="date.errors?.required">Une date est requise</span>
						</div>
					</div>
					<!-- Heure de début -->
					<div class="col-12 col-lg-4">
						<label
							for="inputStartFormation"
							class="form-label theme-main-color fw-bold"
							>Heure de début</label
						>
						<timepicker
							[disabled]="
								(isFormReadOnly && !isTWActive) ||
								(isTWActive && !canBeFullyModified)
							"
							[showSpinners]="
								(!isFormReadOnly && !isTWActive) ||
								(isTWActive && canBeFullyModified)
							"
							class="ms-3"
							id="inputStartFormation"
							[formControlName]="'readyTime'"
							[showMeridian]="false"
						></timepicker>
						<div *ngIf="readyTime.invalid" class="text-danger">
							<span *ngIf="readyTime.errors?.required"
								>Un horaire est requis</span
							>
							<span *ngIf="readyTime.errors['outOfRange']"
								>Veuillez saisir un horaire entre {{ MIN_WORKING_HOUR }}h et
								{{ MAX_WORKING_HOUR }}h</span
							>
						</div>
					</div>
					<!-- Heure de fin -->
					<div class="col-lg-4 col-12">
						<label
							for="inputEndFormation"
							class="form-label theme-main-color fw-bold"
							>Heure de fin</label
						>
						<timepicker
							[disabled]="
								(isFormReadOnly && !isTWActive) ||
								(isTWActive && !canBeFullyModified)
							"
							[showSpinners]="
								(!isFormReadOnly && !isTWActive) ||
								(isTWActive && canBeFullyModified)
							"
							class="ms-3"
							id="inputEndFormation"
							[formControlName]="'dueTime'"
							[showMeridian]="false"
						>
						</timepicker>
						<div *ngIf="dueTime.invalid" class="text-danger">
							<span *ngIf="dueTime.errors?.required"
								>Un horaire est requis</span
							>
							<span *ngIf="dueTime.errors['outOfRange']"
								>Veuillez saisir un horaire entre {{ MIN_WORKING_HOUR }}h et
								{{ MAX_WORKING_HOUR }}h</span
							>
						</div>
					</div>
				</div>

				<div
					*ngIf="
						formationDetailForm.errors &&
						(formationDetailForm.errors.endBeforeStart ||
							formationDetailForm.errors.tooManyHours)
					"
					class="row my-2 text-center"
				>
					<span
						*ngIf="formationDetailForm.errors.endBeforeStart"
						class="text-danger"
						>Veuillez saisir une heure de début inférieur à l'heure de fin</span
					>
					<span
						*ngIf="formationDetailForm.errors.tooManyHours"
						class="text-danger"
						>La durée de la {{ LABEL_INTERVENTION }} ne peut excéder
						{{ MAX_DURATION }}h</span
					>
				</div>
				<!-- Durée -->
				<div class="col-lg-4 col-12" *ngIf="isTWActive">
					<label
						for="inputDurationFormation"
						class="form-label theme-main-color fw-bold"
						>Durée</label
					>
					<timepicker
						[disabled]="isFormReadOnly || !canBeFullyModified"
						[showSpinners]="!isFormReadOnly"
						class="ms-3"
						id="inputDurationFormation"
						[formControlName]="'duration'"
						[showMeridian]="false"
					></timepicker>
					<div *ngIf="duration.invalid" class="text-danger">
						<span *ngIf="duration.errors?.required">Une durée est requise</span>
						<span *ngIf="duration.errors['outOfRange']"
							>Veuillez saisir un horaire entre {{ MIN_WORKING_HOUR }}h et
							{{ MAX_WORKING_HOUR }}h</span
						>
					</div>
				</div>
				<!-- Lieu de prestation -->
				<div class="row my-4">
					<!-- Lien visio ou checkbox visio -->
					<div
						class="col-lg-4 col-12"
						*ngIf="!isAPrescription && (isRemote || canBeFullyModified)"
					>
						<label
							class="form-label theme-main-color fw-bold"
							for="checkRemote"
						>
							{{ LABEL_INTERVENTION | titlecase }} à distance
						</label>
						<span
							*ngIf="isFormReadOnly || !canBeFullyModified"
							class="form-control-plaintext"
						>
							<a
								*ngIf="isRemote"
								[href]="missionRequest.remoteLink"
								target="_blank"
								>Accédez ici</a
							>
						</span>
						<div
							*ngIf="!isFormReadOnly && canBeFullyModified"
							class="form-check"
							id="checkRemote"
						>
							<input
								(change)="onClickCheckRemote()"
								class="form-check-input theme-main-border-color"
								[ngClass]="{
									'theme-main-color-check': isRemote
								}"
								type="checkbox"
								formControlName="isRemote"
							/>
							<div class="alert alert-secondary" role="alert" *ngIf="isRemote">
								<p class="theme-main-color">
									<i class="bi bi-info-circle me-2" aria-hidden="true"></i>
									<em
										>Le lien de la visio sera consultable après la validation du
										formulaire.</em
									>
								</p>
							</div>
						</div>
					</div>
					<!-- Domicile du bénéficiaire -->
					<div *ngIf="shouldDisplayMissionPlace()" class="col-lg-4 col-12">
						<label
							class="form-label theme-main-color fw-bold"
							for="checkMissionPlaceBeneficiaire"
						>
							{{ LABEL_INTERVENTION_CAPITALIZED | titlecase }} au domicile du
							{{ LABEL_BENEFICIAIRE }}
						</label>
						<div
							*ngIf="!isFormReadOnly && canBeFullyModified"
							class="form-check"
							id="checkMissionPlaceBeneficiaire"
						>
							<input
								(change)="resetMissionPlace()"
								class="form-check-input theme-main-border-color"
								[ngClass]="{
									'theme-main-color-check': isMissionPlaceBeneficiaireAddress
								}"
								type="checkbox"
								formControlName="isMissionPlaceBeneficiaireAddress"
							/>
							<span
								*ngIf="
									isMissionPlaceBeneficiaireAddress &&
									selectedBeneficiaire &&
									!(
										selectedBeneficiaire &&
										selectedBeneficiaire.address.longitude &&
										selectedBeneficiaire.address.latitude
									)
								"
								><span class="fw-bold theme-red-color"
									>L'adresse du {{ LABEL_BENEFICIAIRE }} choisi est incorrect </span
								><a
									[routerLink]="[
										'/gestion/beneficiaires/',
										selectedBeneficiaire.id
									]"
									class="theme-main-color"
									>modifier</a
								></span
							>
						</div>
						<span
							*ngIf="isFormReadOnly"
							class="form-control-plaintext theme-main-color"
						>
							<span *ngIf="isMissionPlaceBeneficiaireAddress"
								><i class="bi bi-check-lg" aria-hidden="true"></i
							></span>
							<span *ngIf="!isMissionPlaceBeneficiaireAddress"
								><i class="bi bi-x-lg" aria-hidden="true"></i
							></span>
						</span>
					</div>
					<!-- Mission Place -->
					<div
						class="col-lg-4 col-12"
						*ngIf="
							(isSESSAD || isSAE) &&
							!isReunion &&
							(!isRemote || canBeFullyModified)
						"
					>
						<label
							for="missionPlace"
							class="form-label fw-bold theme-main-color"
						>
							{{ 'Lieu de ' + LABEL_INTERVENTION }}
						</label>
						<span
							*ngIf="(isFormReadOnly || !canBeFullyModified) && !isRemote"
							class="form-control-plaintext"
						>
							{{
								isMissionPlaceBeneficiaireAddress
									? 'Domicile du ' + LABEL_BENEFICIAIRE
									: missionRequest.missionPlace?.nameDisplay
							}}
						</span>
						<input
							*ngIf="!isFormReadOnly && canBeFullyModified"
							autocomplete="off"
							(keyup)="missionPlaceKeyUp($event.target)"
							formControlName="missionPlace"
							[typeahead]="listMissionPlace"
							typeaheadOptionField="nameDisplay"
							[typeaheadItemTemplate]="itemTemplateTypeaheadMissionPlace"
							[typeaheadMinLength]="0"
							placeholder="Saisissez un lieu de prestation"
							class="form-control"
							[typeaheadScrollable]="true"
							(typeaheadOnSelect)="typeaheadMissionPlaceOnSelect($event)"
							[ngClass]="{
								'is-invalid':
									(missionPlace.errors?.required || !selectedMissionPlace) &&
									formationDetailForm?.errors?.missionPlaceRequired,
								'is-valid':
									(missionPlace.dirty || missionPlace.touched) &&
									missionPlace.valid &&
									selectedMissionPlace
							}"
						/>
						<ng-template
							#itemTemplateTypeaheadMissionPlace
							let-model="item"
							let-index="index"
						>
							<span>{{ model.nameDisplay }}</span>
						</ng-template>
						<div
							*ngIf="
								(missionPlace.invalid &&
									(missionPlace.dirty || missionPlace.touched)) ||
								!selectedMissionPlace
							"
							class="text-danger"
						>
							<span
								*ngIf="
									(missionPlace.errors?.required || !selectedMissionPlace) &&
									formationDetailForm?.errors?.missionPlaceRequired
								"
								>Le choix d'un lieu de prestation est requis</span
							>
						</div>
					</div>
					<!-- Adresse lieu prestation -->
					<div
						class="col-lg-4 col-12"
						*ngIf="
							(isSESSAD || isSAE) &&
							!isReunion &&
							!isRemote &&
							!canBeFullyModified
						"
					>
						<label
							for="missionPlace"
							class="form-label fw-bold theme-main-color"
						>
							Adresse de {{ LABEL_INTERVENTION }}
						</label>
						<span class="form-control-plaintext">{{ getAddressLabel() }}</span>
					</div>
				</div>
				<div class="row my-4">
					<!-- Type de mission -->
					<div
						class="col-lg-4 col-12"
						[ngClass]="{ 'offset-4': isSSIAD }"
						*ngIf="!isReunion && !isSSIAD"
					>
						<label
							for="missionType"
							class="form-label fw-bold theme-main-color"
						>
							Type de mission
						</label>
						<span
							*ngIf="isFormReadOnly || !canBeFullyModified"
							class="form-control-plaintext"
							>{{ missionRequest.missionType.type }}</span
						>
						<input
							*ngIf="!isFormReadOnly && canBeFullyModified"
							autocomplete="off"
							(keyup)="missionTypeKeyUp($event.target)"
							formControlName="missionType"
							[typeahead]="listMissionTypes"
							typeaheadOptionField="type"
							[typeaheadItemTemplate]="itemTemplateTypeaheadMissionType"
							[typeaheadMinLength]="0"
							placeholder="Saisissez un type d'intervention"
							class="form-control"
							[typeaheadScrollable]="true"
							(typeaheadOnSelect)="typeaheadMissionTypeOnSelect($event)"
							[ngClass]="{
								'is-valid':
									(missionType.dirty || missionType.touched) &&
									missionType.valid &&
									selectedMissionType
							}"
						/>
						<ng-template
							#itemTemplateTypeaheadMissionType
							let-model="item"
							let-index="index"
						>
							<span>{{ model?.type }}</span>
						</ng-template>

						<div
							*ngIf="
								(missionType.invalid &&
									(missionType.dirty || missionType.touched)) ||
								!selectedSpeciality
							"
							class="invalid-feedback"
						>
							<span *ngIf="missionType.errors?.required || !selectedMissionType"
								>Le choix d'un type d'intervention est requis</span
							>
						</div>
					</div>
					<!-- Spécialité -->
					<div
						class="col-lg-4 col-12"
						[ngClass]="{ 'offset-4': isSSIAD }"
						*ngIf="!isReunion && !isSSIAD"
					>
						<label for="speciality" class="form-label fw-bold theme-main-color">
							Spécialité
						</label>
						<span
							*ngIf="isFormReadOnly || !canBeFullyModified"
							class="form-control-plaintext"
							>{{
								missionRequest.careSpecialty
									? missionRequest.careSpecialty.name
									: 'Sans'
							}}</span
						>
						<input
							*ngIf="!isFormReadOnly && canBeFullyModified"
							autocomplete="off"
							(keyup)="specialityKeyUp($event.target)"
							formControlName="speciality"
							[typeahead]="listSpecialite"
							typeaheadOptionField="name"
							[typeaheadItemTemplate]="itemTemplateTypeaheadSpeciality"
							[typeaheadMinLength]="0"
							placeholder="Saisissez une spécialité"
							class="form-control"
							[typeaheadScrollable]="true"
							(typeaheadOnSelect)="typeaheadSpecialityOnSelect($event)"
							[ngClass]="{
								'is-valid':
									(speciality.dirty || speciality.touched) &&
									speciality.valid &&
									selectedSpeciality
							}"
						/>
						<ng-template
							#itemTemplateTypeaheadSpeciality
							let-model="item"
							let-index="index"
						>
							<span>{{ model?.name }}</span>
						</ng-template>

						<div
							*ngIf="
								(speciality.invalid &&
									(speciality.dirty || speciality.touched)) ||
								!selectedSpeciality
							"
							class="invalid-feedback"
						>
							<span *ngIf="speciality.errors?.required || !selectedSpeciality"
								>Le choix d'une spécialité est requis</span
							>
						</div>
					</div>

					<!-- Type de préparation -->
					<div
						class="col-lg-4 col-12"
						[ngClass]="{ 'offset-4': isSSIAD }"
						*ngIf="!isReunion && isSESSAD"
					>
						<label
							for="preparationTimePercentage"
							class="form-label theme-main-color fw-bold"
							>Temps de préparation:
						</label>
						<span
							*ngIf="isFormReadOnly || !canBeFullyModified"
							class="form-control-plaintext"
						>
							{{ selectedPreparationTime?.label }} ({{
								selectedPreparationTime?.time
							}}%)
						</span>
						<select
							class="form-select form-control"
							id="preparationTimePercentage"
							[formControlName]="'preparationTimePercentage'"
							aria-label="Temps de préparation"
							*ngIf="!isFormReadOnly && canBeFullyModified"
						>
							<option
								*ngFor="let preparationTime of preparationTimeList"
								value="{{ preparationTime.time }}"
								[selected]="
									preparationTime.time ===
									this.missionRequest.preparationTimePercentage
								"
							>
								{{ preparationTime.label }} ({{ preparationTime.time }}%)
							</option>
						</select>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-4">
						<label for="model" class="form-label fw-bold">Service</label>
						<div class="col-4" *ngIf="isFormReadOnly">
							<span class="form-control-plaintext">{{
								missionRequest.centerDepartment?.name
							}}</span>
						</div>

						<input
							*ngIf="!isFormReadOnly"
							class="form-control"
							autocomplete="off"
							formControlName="centerDepartment"
							placeholder="Saisissez un service"
							[typeahead]="centerDepartments"
							[typeaheadOptionField]="'name'"
							[typeaheadMinLength]="0"
							[typeaheadScrollable]="true"
							(typeaheadOnSelect)="typeaheadCenterDepartmentOnSelect($event)"
							(keyup)="centerDepartmentsKeyUp($event.target)"
							[ngClass]="{
								'is-valid':
									(centerDepartment.dirty || centerDepartment.touched) &&
									centerDepartment.valid &&
									selectedCenterDepartment
							}"
						/>
					</div>
				</div>
				<!-- Affichage de l'intervenant associé à la mission -->
				<div class="row my-4">
					<div
						class="col-lg-4 col-12"
						[ngClass]="{ 'offset-4': isSSIAD }"
						*ngIf="
							!isReunion &&
							!isSSIAD &&
							this.missionRequest?.nombreIntervenant === 1
						"
					>
						<label
							for="missionType"
							class="form-label fw-bold theme-main-color"
						>
							{{ LABEL_INTERVENANT_CAPITALIZED }}
						</label>
						<span
							*ngIf="isFormReadOnly || !canBeFullyModified"
							class="form-control-plaintext"
							>{{ getEmployeeOfMission() }}</span
						>
					</div>

                    <div class="col-lg-4 col-12"
						*ngIf="
							this.missionRequest?.nombreIntervenant === 1
						">
                        <label
                                for="missionType"
                                class="form-label fw-bold theme-main-color"
                        >
                            Adresse de départ
                        </label>
                        <span
                                *ngIf="isFormReadOnly || !canBeFullyModified"
                                class="form-control-plaintext"
                        >{{ getDepartureAddress() }}</span
                        >
                    </div>

					<div class="col-lg-4 col-12">
						<label
							for="reminderStatus"
							class="form-label fw-bold theme-main-color"
						>
							Rappel automatique par email au bénéficiaire
						</label>
						<span class="form-control-plaintext" *ngIf="isFormReadOnly">
							{{
								this.missionRequest.reminderStatus === 'ACTIVE' ||
								this.missionRequest.reminderStatus === 'SENT'
									? 'Activé'
									: 'Désactivé'
							}}
						</span>
						<div
							class="form-check d-flex justify-content-center align-items-center"
							id="checkReminder"
							*ngIf="!isFormReadOnly"
						>
							<input
								class="form-check-input theme-main-border-color fs-5"
								[ngClass]="{ 'theme-main-color-check': reminder }"
								type="checkbox"
								formControlName="reminder"
							/>
						</div>
					</div>
				</div>
				<!-- DÉBUT DE LA ZONE PARTICIPANTS -->
				<div class="row">
					<div
						class="col"
						*ngIf="isFormReadOnly && this.missionRequest?.nombreIntervenant > 1"
					>
						<label for="inputArea" class="form-label theme-main-color fw-bold"
							>{{ LABEL_INTERVENANT_CAPITALIZED }}(s) (nombre prévu :
							{{ this.missionRequest?.nombreIntervenant }})
						</label>
						<span *ngIf="isFormReadOnly" class="form-control-plaintext">
							<p *ngFor="let attendee of listOfAttendees">
								{{ attendee.firstName + ' ' + attendee.lastName }}
							</p>
						</span>
					</div>
					<div
						class="col"
						*ngIf="
							!isFormReadOnly && this.missionRequest?.nombreIntervenant > 1
						"
					>
						<label class="form-label theme-main-color fw-bold"
							>{{ LABEL_INTERVENANT_CAPITALIZED }}(s) (prévision initiale :
							{{ initialNbrOfEmployeeRequiredForThisMission }})</label
						>
						<br />

						<div class="input-group w-50 mb-4" *ngIf="!isReunion">
							<span class="input-group-text">Nombre :</span>
							<input
								type="number"
								min="1"
								[max]="maxIntervenantSelectableForMission"
								class="form-control"
								[formControlName]="'nombreIntervenants'"
								aria-label="Nombre d'intervenants"
								(change)="checkValidityOfNumberOfEmployee()"
							/>
							<span class="input-group-text fw-bold"
								>(maximum : {{ maxIntervenantSelectableForMission }} )</span
							>
						</div>
						<div
							class="alert alert-warning"
							role="alert"
							*ngIf="
								!isNumberOfIntervenantSelectedValid &&
								!isReunion &&
								!isDisplayableErrorSelectedEmployeesHigherThanNumberSelected
							"
						>
							Valeur incorrecte (minimum possible : 0 ; maximum possible :
							{{ maxIntervenantSelectableForMission }} )
						</div>

						<span
							class="d-inline-block bg-light rounded border border-1 theme-main-border-color thumbnail m-1"
							*ngFor="let p of this.listOfAttendees"
						>
							<span class="m-2 theme-main-color">{{
								p.firstName + ' ' + p.lastName
							}}</span>
							<button
								class="btn-sm"
								(click)="removeParticipant(p)"
								[disabled]="
									p.id === user?.employee.id && !isMissionWithMultipleEmployee
								"
								[ngClass]="{
									'theme-red-button':
										p.id !== user?.employee.id || isMissionWithMultipleEmployee,
									'theme-green-button':
										p.id === user?.employee.id && !isMissionWithMultipleEmployee
								}"
							>
								<i
									class="bi bi-x-lg"
									*ngIf="
										p.id !== user?.employee.id || isMissionWithMultipleEmployee
									"
									aria-hidden="true"
								></i>
								<i
									class="bi bi-pin-fill"
									aria-hidden="true"
									*ngIf="
										p.id === user?.employee.id && !isMissionWithMultipleEmployee
									"
								></i>
							</button>
						</span>
						<div class="row pb-3" *ngIf="isDisplayableSelectEmployee">
							<div class="col-9 mt-3 mb-3">
								<input
									*ngIf="user?.role.id !== Authority.CHARGE_MISSION"
									autocomplete="off"
									[ngModelOptions]="{ standalone: true }"
									[typeahead]="listEmployeeMapped"
									typeaheadOptionField="name"
									[typeaheadItemTemplate]="itemTemplateTypeaheadEmployeeReunion"
									[typeaheadMinLength]="0"
									[placeholder]="messageInviteIntervenantParticipant"
									class="form-control"
									[typeaheadScrollable]="true"
									(typeaheadOnSelect)="
										typeaheadEmployeeOnSelectForMissionWithMultipleEmployee(
											$event
										)
									"
									[(ngModel)]="selectedParticipant"
								/>
								<ng-template
									#itemTemplateTypeaheadEmployeeReunion
									let-model="item"
									let-index="index"
								>
									<span *ngIf="user?.role.id !== Authority.CHARGE_MISSION">{{
										model.name
									}}</span>
								</ng-template>
							</div>
							<div class="col mt-3 mb-3">
								<button
									type="button"
									class="btn theme-main-color-button"
									(click)="resetParticipantsReunion()"
									*ngIf="isReunion"
								>
									Effacer
								</button>
							</div>
						</div>

						<div
							class="alert alert-warning mt-2"
							role="alert"
							*ngIf="
								!isReunion &&
								isDisplayableErrorSelectedEmployeesHigherThanNumberSelected
							"
						>
							Nombre d'intervenants sélectionné trop élevé (maximum :
							{{ this.formationDetailForm.value.nombreIntervenants }}).
						</div>
					</div>
				</div>
				<!-- FIN DE LA ZONE PARTICIPANTS -->

				<div class="row my-4">
					<!-- Notes -->
					<div class="col-12">
						<label for="inputNotes" class="form-label theme-main-color fw-bold"
							>Notes</label
						>

						<textarea
							class="form-control"
							id="inputNotes"
							formControlName="notes"
							[readonly]="isFormReadOnly"
							(input)="adjustTextareaHeight()"
							[ngClass]="{
								'bg-transparent border-light ps-0': isFormReadOnly,
								'is-invalid': notes.invalid,
								'is-valid': notes.dirty && notes.valid
							}"
						></textarea>
						<div
							*ngIf="notes.invalid && (notes.dirty || notes.touched)"
							class="invalid-feedback"
						>
							<span *ngIf="notes.errors?.maxlength"
								>Les notes ne peuvent exceder
								{{ MAX_NOTES_LENGTH }} caractères</span
							>
						</div>
					</div>
				</div>
			</form>
		</div>
		<div class="row my-4">
			<div class="d-flex justify-content-end">
				<button
					*ngIf="isFormReadOnly"
					class="btn theme-main-color-button mx-1 px-3"
					(click)="openCopyMissionModal(modalCopyMission)"
				>
					Copier {{ LABEL_INTERVENTION }}
				</button>
				<button
					*ngIf="this.missionRequest.nombreIntervenant === 1 && !this.isSAE"
					class="btn theme-main-color-button mx-2 px-3"
					(click)="addIntervenants()"
				>
					Activer intervenants multiples
				</button>
				<button
					*ngIf="isFormReadOnly && isEditable"
					class="btn theme-main-color-button"
					(click)="editForm()"
				>
					<i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier les
					informations
				</button>
				<button
					*ngIf="!isFormReadOnly"
					class="btn theme-main-color-button mx-3 px-3"
					(click)="stopEditForm(false)"
				>
					Annuler
				</button>
				<button
					*ngIf="
						!isFormReadOnly && !canBeFullyModified && !this.isProfessionnelSAE
					"
					class="btn theme-main-color-button mx-3 px-3"
					(click)="unassignedMission()"
				>
					Désaffecter la mission
				</button>
				<button
					*ngIf="!isFormReadOnly"
					[disabled]="
						!formationDetailForm.valid ||
						(formationDetailForm.errors?.beneficiaireRequired &&
							!selectedBeneficiaire) ||
						(formationDetailForm.errors?.missionPlaceRequired &&
							!selectedMissionPlace &&
							(isSESSAD || isSAE) &&
							!isMissionPlaceBeneficiaireAddress) ||
						(isMissionPlaceBeneficiaireAddress &&
							selectedBeneficiaire &&
							!(
								selectedBeneficiaire &&
								selectedBeneficiaire.address.longitude &&
								selectedBeneficiaire.address.latitude
							)) ||
						isValidateButtonClicked
					"
					class="btn theme-green-button"
					type="submit"
					form="formationDetailForm"
				>
					<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
				</button>
			</div>
		</div>
	</div>
</div>

<ng-template #deleteFormation>
	<div class="modal-header text-center">
		<h4>Suppression {{ LABEL_INTERVENTION }}</h4>
		<button
			type="button"
			class="btn-close"
			data-bs-dismiss="modal"
			aria-label="Close"
			(click)="confirmDeleteModalRef.hide()"
		>
			<span aria-hidden="true"></span>
		</button>
	</div>

	<div class="modal-body">
		<span *ngIf="missionRequest.isPartOfAGroup">
			La {{ LABEL_INTERVENTION | lowercase }} fait partie d'une série de
			{{ LABEL_INTERVENTION | lowercase }}s.<br />
			Voulez-vous effectuer la suppression :<br /><br />
			<div class="mb-3">
				<a
					(click)="updateMissionRqChoice(1)"
					[ngClass]="{
						'theme-main-color-check text-white': updateGroupChoice === 1,
						'theme-main-color-button': updateGroupChoice !== 1
					}"
					class="btn btn-block"
				>
					Pour cette {{ LABEL_INTERVENTION | lowercase }}</a
				>
			</div>
			<div class="mb-3">
				<a
					class="btn btn-block"
					[ngClass]="{
						'theme-main-color-check text-white': updateGroupChoice === 2,
						'theme-main-color-button': updateGroupChoice !== 2
					}"
					(click)="updateMissionRqChoice(2)"
				>
					Pour cette {{ LABEL_INTERVENTION | lowercase }} et les suivantes de la
					série</a
				>
			</div>
			<div class="mb-3">
				<a
					class="btn btn-block"
					[ngClass]="{
						'theme-main-color-check text-white': updateGroupChoice === 3,
						'theme-main-color-button': updateGroupChoice !== 3
					}"
					(click)="updateMissionRqChoice(3)"
				>
					Pour toutes les {{ LABEL_INTERVENTION | lowercase }}s de la série</a
				>
			</div>
		</span>
		<span *ngIf="!missionRequest.isPartOfAGroup">
			Êtes-vous sûr de vouloir effectuer la suppression ?
		</span>
	</div>
	<div class="modal-footer">
		<span *ngIf="missionRequest.isPartOfAGroup">
			<button
				[disabled]="
					updateGroupChoice === 0 || isConfirmDeleteMissionButtonDisabled
				"
				class="btn theme-green-button"
				(click)="deleteMission(updateGroupChoice)"
			>
				Valider
			</button>
		</span>
		<span *ngIf="!missionRequest.isPartOfAGroup">
			<a
				(click)="confirmDeleteModalRef.hide()"
				class="btn theme-main-color-button"
				>Non</a
			>
			<button
				[disabled]="isConfirmDeleteMissionButtonDisabled"
				class="btn theme-red-button ms-3"
				(click)="deleteMission()"
			>
				Oui
			</button>
		</span>
	</div>
</ng-template>

<ng-template #confirmUpdateForGroupTemplate>
	<div class="modal-header text-center">
		<h4>Sauvegarde des modifications</h4>
		<button
			type="button"
			class="btn-close"
			data-bs-dismiss="modal"
			aria-label="Close"
			(click)="confirmUpdateForGroupTemplateRef.hide()"
		>
			<span aria-hidden="true"></span>
		</button>
	</div>
	<div class="modal-body">
		La {{ LABEL_INTERVENTION | lowercase }} modifiée fait partie d'une série de
		{{ LABEL_INTERVENTION | lowercase }}s.<br />
		Voulez-vous effectuer les modifications :<br /><br />
		<div class="mb-3">
			<a
				(click)="updateMissionRqChoice(1)"
				[ngClass]="{
					'theme-main-color-check text-white': updateGroupChoice === 1,
					'theme-main-color-button': updateGroupChoice !== 1
				}"
				class="btn btn-block"
			>
				Pour cette {{ LABEL_INTERVENTION | lowercase }}</a
			>
		</div>
		<div class="mb-3">
			<a
				class="btn btn-block"
				[ngClass]="{
					'theme-main-color-check text-white': updateGroupChoice === 2,
					'theme-main-color-button': updateGroupChoice !== 2
				}"
				(click)="updateMissionRqChoice(2)"
			>
				Pour cette {{ LABEL_INTERVENTION | lowercase }} et les suivantes de la
				série</a
			>
		</div>
		<div class="mb-3">
			<a
				class="btn btn-block"
				[ngClass]="{
					'theme-main-color-check text-white': updateGroupChoice === 3,
					'theme-main-color-button': updateGroupChoice !== 3
				}"
				(click)="updateMissionRqChoice(3)"
			>
				Pour toutes les {{ LABEL_INTERVENTION | lowercase }}s de la série</a
			>
		</div>
	</div>
	<div class="modal-footer">
		<button
			[disabled]="updateGroupChoice === 0"
			class="btn theme-green-button"
			(click)="updateMissionRq(updateGroupChoice)"
		>
			Valider
		</button>
	</div>
</ng-template>

<ng-template #modalSuppressionAssignedToPlanning>
	<div class="modal-header">
		<h4 class="modal-title text-center">
			{{ LABEL_INTERVENTION_CAPITALIZED }} affectée dans le planning,
			voulez-vous vraiment l'annulée ?
		</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="modalSuppressionAssignedToPlanningRef?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="d-flex justify-content-evenly">
			<button
				class="btn theme-main-color-button float-start"
				(click)="modalSuppressionAssignedToPlanningRef?.hide()"
			>
				Retour
			</button>
			<button
				class="btn theme-red-button"
				(click)="cancelMission('beneficiaire')"
			>
				Oui (bénéficiaire absent)
			</button>
			<button
				class="btn theme-red-button"
				(click)="cancelMission('intervenant')"
			>
				Oui (intervenant absent)
			</button>
		</div>
	</div>
</ng-template>

<ng-template #modalCopyMission>
	<div class="modal-header">
		<h4 class="modal-title text-center">Copier {{ LABEL_INTERVENTION }}</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="copyMissionModalRef?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="mb-5">
			<span class="fw-bold theme-main-color mb-2">Date désirée : </span>
			<input
				autocomplete="off"
				type="text"
				bsDatepicker
				class="form-control"
				name="date"
				class="bg-transparent border-light ps-0 mb-3"
				[(ngModel)]="dateToAdd"
				(onHidden)="addDateToListOfDates()"
			/>
			<div class="mb-5">
				<span class="fw-bold theme-main-color mb-3"
					>Dates sélectionnées :
				</span>
				<div>
					<div
						class="d-inline-block bg-light rounded border border-1 theme-main-border-color thumbnail m-1"
						*ngFor="let date of listOfDates"
					>
						<span class="dateaffiche m-2 theme-main-color">{{
							date | date : 'dd/MM/yyyy'
						}}</span>
						<button
							class="monbuton btn-sm btn-danger"
							(click)="removeDateFromList(date)"
						>
							Supprimer
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="d-flex justify-content-evenly">
			<button
				class="btn theme-main-color-button float-start"
				(click)="copyMissionModalRef?.hide()"
			>
				Retour
			</button>
			<button class="btn theme-green-button" (click)="copyMission()">
				Valider
			</button>
		</div>
	</div>
</ng-template>
